import { render } from "./GridGallerySection.vue?vue&type=template&id=74772e4a"
import script from "./GridGallerySection.vue?vue&type=script&lang=js"
export * from "./GridGallerySection.vue?vue&type=script&lang=js"

import "./GridGallerySection.vue?vue&type=style&index=0&id=74772e4a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__